<!--低碳生活-->
<template>
  <div>
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <!--面包屑-->
      <el-col :span="16">
        <div class="grid-content">
          <el-breadcrumb class='crumbs' separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">地球牧歌</a></el-breadcrumb-item>
            <el-breadcrumb-item>{{this.subtitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid-content1">
          <el-tabs :tab-position="tabPosition" @tab-click="jump"  v-model='activeName' >
            <el-tab-pane :label="item.name" :name="item.stringId" v-for="item in tableListData" :key="item.stringId" >
              <h2>{{item.name}}</h2>
              <ul v-for="item1 in newsListData" :key="item1.stringId" @click="details(item1)">
                <li class='content'>
                  <ul>
                    <li class='icon'>
                      <i class="el-icon-document"></i>
                    </li>
                    <li class='title'>
                      <a>{{item1.title}}</a>
                    </li>
                    <li class='date'>
                      <span>{{item1.creteNewTime}}</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <!--分页-->
              <el-pagination  class="pagination"
                              v-show="total>0"
                              :total="total"
                              :current-page.sync="queryParams.pageNum"
                              :page-size.sync="queryParams.pageSize"
                              @current-change="getHomeResearchNews"
              >
              </el-pagination>

            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
    </el-row>
  </div>
</template>

<script>
import {earthPastoral,homeResearchNews} from '@/api/auth'
import {h} from "vue";
export default {
  activated() {
    this.getList();
    // this.getHomeResearchNews();
  },
  data () {
    return {
      fits: ['cover'],
      tabPosition: 'left',
      activeName: 'tab1',
      tableListData: [],
      newsListData: [],
      subtitle:'',
      queryParams:{
      },
      // 总条数
      total: 0,
      queryNewsParams:{
        pageNum: 1,
        pageSize: 10,
        type:'7',
        category:'1'
      },
    }
  },
  methods: {
    getList() {
      let that = this;
      earthPastoral(this.queryParams).then(res => {
        that.tableListData=res.data.categories;
        that.total = res.data.newsContentVoIPage.total;
        that.newsListData=res.data.newsContentVoIPage.records;
        that.activeName=that.tableListData[0].stringId;
      })
    },
    getHomeResearchNews() {
      let that = this;
      homeResearchNews(this.queryNewsParams).then(res => {
        that.total = res.data.total;

        that.newsListData=res.data.records;
      })
    },
    jump(tab, event) {
      this.subtitle=tab.label;
      if(this.subtitle!='地球牧歌俱乐部'){
        this.queryNewsParams.category='7';
      }else{
        this.queryNewsParams.category='1';
      }
      this.queryNewsParams.type=tab.name;
      this.getHomeResearchNews();
    },
    details(raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
        },
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pagination {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 50px;
}
.el-row {
  padding-bottom: 20px;
  background-color: #eee;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  height: 50px;
  //面包屑
  .crumbs{
    line-height:50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
}
::v-deep .el-tabs__content{
  padding-bottom: 20px;
  background-color: #fff;
}
.grid-content1 {
  min-height: 100px;
  h2{
    height: 50px;
    width: 100%;
    background-color: #fff;
    font-size: 16px;
    font-family: " 黑体";
    font-weight: bold;
    line-height: 50px;
    padding-left: 15px;
    color: #333;
  }
  .content{
    height: 50px;
    padding: 0 15px;
    background-color: #fff;
    border-bottom: 1px dashed #999;
    line-height: 50px;
    .icon{
      width:2.5%;
      float: left;
    }
    .title{
      width:85%;
      float: left;
      a{
        width: 100%;
        display: block;
        color: #666;
        font-family: " 黑体";
        overflow: hidden;        /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow:ellipsis;  /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap;     /*文本不换行*/
      }
      a:hover{
        color:#409EFF ;
      }
    }
    .date{
      width:12.5%;
      float: right;
      text-align: right;
    }
  }
  .paging{
    width: 100%;
    height: 80px;
    background-color: #fff;
    .pagination{
      float: right;
      margin-top: 20px;
    }
  }
}
//分页
.pagination{
  margin-top: 15px;
  float: right;
}
//tabs选项卡
::v-deep .el-tabs{
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left{
  text-align: center;
  height:46px;
  width: 280px;
  font-family: Tahoma;
  font-size: 14px;
  color: #333;
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:hover{
  background-color: #6aa84f;
  color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:focus{
  background-color: #6aa84f;
  color: #fff;
}

// 默认选中的样式
::v-deep .el-tabs--left .el-tabs__item.is-active {
  background-color: #6aa84f;
  color: #fff;
}
</style>
